import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchDirectoryNoStateMachineProps = { startDate: Moment; endDate: Moment };

export type FetchDirectoryNoStateMachine = (
  dates: FetchDirectoryNoStateMachineProps,
) => void;

const fetchDirectoryNoStateMachine = ({
  startDate,
  endDate,
}: FetchDirectoryNoStateMachineProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport("directory_ads_without_state_machine", dispatch, params);
};

export default fetchDirectoryNoStateMachine;
